






































































































































































































































































































import BaseEdit from './BaseEdit';
import { Component, Provide, Vue, Watch, Prop } from 'vue-property-decorator';
import { EventBus } from '@/event-bus';
import { mapGetters } from 'vuex';
import axios from 'axios';
import Constants from '@/constants';

@Component({
  props: ['isOpen', 'donorId', 'patientId', 'patientCreateDate'],
})
export default class ApproveModal extends Vue {
  @Provide() parentValidator = this.$validator;

  @Prop()
  isOpen: any = false;

  @Prop()
  donorId: any;

  @Prop()
  patientId: any;

  @Prop()
  patientCreateDate: any;

  preferences: any[] = [];
  anticoagulantTypes: any[] = [];

  form: any = {};

  created() {
      this.anticoagulantTypes = [
      { key: 1, value: this.$t('Гепарин IU/ml') },
      { key: 2, value: 'ACD vol' },
    ];
    this.preferences = [
      { key: 1, value: this.$t('если не возможно первое предпочтение') },
      { key: 2, value: this.$t('предпочтительнее') },
      { key: 3, value: this.$t('вторичное предпочтение') },
    ];

    }

  @Watch('isOpen')
  openApproveModal(val: string, oldVal: string) {
    if (val) {
      axios.get(`/DonorsAtWork/GetDonorApprove?patientId=${this.patientId}&donorId=${this.donorId}`)
           .then((response) => {
                                  this.form = response.data;
                                  this.showModal();
                                });      
    } else {
      this.hideModal();
    }
  }

  async generateGskForm() {
    if (await this.$validator.validateAll()) {
      let url =
        Constants.baseUrl + `/DonorsAtWork/GskForm?donorId=${this.donorId}&patientId=${this.patientId}`;
      this.form.userId = this.$auth.user().id;

      for (let prop in this.form) {
        if(prop === 'rhs' || prop === 'bloodTypes' || prop === 'cmvStatuses') {
          continue;
        }

        if (
          prop == 'samplingDate1' ||
          prop == 'samplingDate2' ||
          prop == 'samplingDate3'
        ) {
          url +=
            '&' +
            prop +
            '=' +
            (this.form[prop] ? this.form[prop].toJSON() : '');
        } else {
          url += '&' + prop + '=' + (this.form[prop] || '');
        }
      }

      this.hideModal();
      EventBus.$emit("showThrobber");
      axios
        .get(url)
        .then(response => {
          EventBus.$emit("hideThrobber");
          EventBus.$emit("success", { msg: this.$t('Запрос на заготовку сформирован!') });
          this.$emit("approveDonor", response.data);            
        })
        .catch(error => {
          EventBus.$emit("error", { msg: error.data.message });
        })
        .finally(() => {
          EventBus.$emit('hideThrobber');
        });
    }
  }

  approve() {
    this.$validator.validateAll().then((result) => {
      if(result)
      {
        this.generateGskForm();     
      }      
    });
  }

  showModal() {
    this.$root.$emit('bv::show::modal', 'approve-modal' + this.donorId);
  }

  hideModal() {
    this.$root.$emit('bv::hide::modal', 'approve-modal' + this.donorId);
    this.$emit('closeModal');
  }
}
